import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registerdoc-grid',
  templateUrl: './registerdoc-grid.component.html',
  styleUrls: ['./registerdoc-grid.component.css']
})
export class RegisterdocGridComponent implements OnInit {

  title="View Registered Documents";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landprocurement/registereddoc/registerdoc-grid/registerdoc-grid.component.ts